import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('SingleBadge');

const SingleBadge = (props) => {
    const {
        className,
        badge: { label, sale = false, craftmanship = false } = {},
        onSale = false,
        hasDotAlert = false,
        considered = false,
        translation = '',
        onBadgeClick = undefined,
        hasBackGround = true,
    } = props;

    const text = considered ? translation : label;
    if (!text) return null;

    const divRef = React.createRef();
    const [isMultilineBadge, setIsMultilineBadge] = useState(false);

    useEffect(() => {
        if (divRef?.current?.children) {
            if (divRef.current.children[0].offsetTop !== divRef.current.children[1].offsetTop) {
                setIsMultilineBadge(true);
            }
        }
    }, []);

    const showBackground = hasBackGround && !considered && !hasDotAlert;

    const modifiers = {
        dotAlert: hasDotAlert,
        highlighted: onSale,
        saleBadge: sale,
        consideredBadge: considered,
        craftBadge: craftmanship,
    };

    const badgeContainerModifiers = {
        multiLine: isMultilineBadge,
    };

    return (
        <div className={bem('badge', modifiers, className)} onClick={onBadgeClick}>
            <div className={showBackground ? bem('badgeContainer', badgeContainerModifiers) : ''} ref={divRef}>
                <span></span>
                {text}
                <span></span>
            </div>
        </div>
    );
};

SingleBadge.propTypes = {
    className: PropTypes.string,
    badge: PropTypes.shape({
        label: PropTypes.string,
        key: PropTypes.string,
        sale: PropTypes.bool,
        craftmanship: PropTypes.bool,
    }),
    onSale: PropTypes.bool,
    hasDotAlert: PropTypes.bool,
    considered: PropTypes.bool,
    translation: PropTypes.string,
    onBadgeClick: PropTypes.func,
    hasBackGround: PropTypes.bool,
};

export default SingleBadge;
